module.exports = __webpack_public_path__ + "static/pexels-photo-1181715-compressor-5cf438a38116ae74a314cae8e8929e58.jpeg";